(() => {
  const bar = document.getElementById('zok-return-buy');
  const jump = document.getElementById('zok-return-buy-button');
  const main = document.getElementById('MainContent');
  if (!bar || !jump || !main) return;
  const submit = main.querySelector('button[name="add"], button[id*="ProductSubmitButton"]');
  if (!submit) return;
  const controls = submit.closest('product-form-component') || submit.closest('form') || submit;
  const observer = new IntersectionObserver(([entry]) => {
    const dialogOpen = Array.from(document.querySelectorAll('dialog[open]')).some(el => el.getClientRects().length);
    bar.hidden = !(entry.boundingClientRect.bottom < 0 && !entry.isIntersecting && !dialogOpen);
  });
  observer.observe(controls);
  jump.addEventListener('click', () => {
    controls.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
    submit.focus({preventScroll:true});
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') bar.hidden = true; });
})();
